/**
 * Testimonial Data
 * Static data for client testimonials
 */

import { Testimonial } from '../types/testimonial';

export const testimonials: Testimonial[] = [
  {
    id: 'test-001',
    name: 'Sarah M.',
    location: 'Orlando, FL',
    courseTaken: 'CPR & AED Certification',
    rating: 5,
    quote:
      'The instructor was amazing and made the class engaging. I feel confident that I could actually help someone in an emergency now. The hands-on practice was invaluable, and I got my certification card the same day!',
    date: '2024-10-15',
    featured: true,
    approved: true,
  },
  {
    id: 'test-002',
    name: 'Michael T.',
    location: 'Atlanta, GA',
    courseTaken: 'BLS for Healthcare Providers',
    rating: 5,
    quote:
      "As an RN, I need to renew my BLS every two years. This was by far the best BLS course I've taken. The instructor was knowledgeable, the scenarios were realistic, and the whole process was smooth and professional.",
    date: '2024-09-22',
    featured: true,
    approved: true,
  },
  {
    id: 'test-003',
    name: 'Jennifer L.',
    location: 'Winter Park, FL',
    courseTaken: 'CPR Renewal',
    rating: 5,
    quote:
      'Quick and convenient renewal class! I appreciated the refresher on the latest techniques. The blended learning option let me do the theory online and just come in for the skills assessment. Highly recommend!',
    date: '2024-10-08',
    featured: false,
    approved: true,
  },
  {
    id: 'test-004',
    name: 'David R.',
    location: 'Marietta, GA',
    courseTaken: 'CPR & AED Certification',
    rating: 4,
    quote:
      'Great class! The instructor was patient and answered all our questions. I wish the class was a bit shorter, but I understand the importance of thorough training. Would definitely recommend to others.',
    date: '2024-09-18',
    featured: false,
    approved: true,
  },
  {
    id: 'test-005',
    name: 'Amanda K.',
    location: 'Orlando, FL',
    courseTaken: 'Group & On-Site Training',
    rating: 5,
    quote:
      'We had our entire daycare staff certified through CPR Training Direct. The instructor came to our facility, which was so convenient! Everyone passed, and we all feel prepared to handle emergencies with the children.',
    date: '2024-08-30',
    featured: true,
    approved: true,
  },
  {
    id: 'test-006',
    name: 'Carlos G.',
    location: 'Atlanta, GA',
    courseTaken: 'BLS for Healthcare Providers',
    rating: 5,
    quote:
      'Excellent course for healthcare professionals. The team dynamics section was particularly helpful. Got my American Heart Association certification the same day. Worth every penny!',
    date: '2024-10-12',
    featured: false,
    approved: true,
  },
  {
    id: 'test-007',
    name: 'Lisa P.',
    location: 'Kissimmee, FL',
    courseTaken: 'CPR & AED Certification',
    rating: 5,
    quote:
      'As a new teacher, I needed to get CPR certified for my job. This class was informative, well-organized, and actually fun! The instructor used real-life scenarios that made the training stick. I feel prepared and confident.',
    date: '2024-09-25',
    featured: false,
    approved: true,
  },
  {
    id: 'test-008',
    name: 'Robert H.',
    location: 'Decatur, GA',
    courseTaken: 'CPR Renewal',
    rating: 4,
    quote:
      'Good renewal course. The instructor was knowledgeable and the facility was clean and professional. Class was exactly what I needed to maintain my certification for work.',
    date: '2024-08-15',
    featured: false,
    approved: true,
  },
  {
    id: 'test-009',
    name: 'Maria S.',
    location: 'Orlando, FL',
    courseTaken: 'CPR & AED Certification',
    rating: 5,
    quote:
      'I was nervous about taking a CPR class, but the instructor made it so easy to understand. The practice with the mannequins really helped me learn the proper technique. I highly recommend this to any parent!',
    date: '2024-10-05',
    featured: false,
    approved: true,
  },
  {
    id: 'test-010',
    name: 'James W.',
    location: 'Atlanta, GA',
    courseTaken: 'Group & On-Site Training',
    rating: 5,
    quote:
      'Brought the training to our office for 15 employees. The instructor was professional, engaging, and made sure everyone was comfortable with the material. Great value for group training. Will definitely use again!',
    date: '2024-09-10',
    featured: false,
    approved: true,
  },
];

/**
 * Get featured testimonials
 */
export const getFeaturedTestimonials = (): Testimonial[] => {
  return testimonials.filter((testimonial) => testimonial.featured && testimonial.approved);
};

/**
 * Get approved testimonials only
 */
export const getApprovedTestimonials = (): Testimonial[] => {
  return testimonials.filter((testimonial) => testimonial.approved);
};

/**
 * Get testimonials by course
 */
export const getTestimonialsByCourse = (courseName: string): Testimonial[] => {
  return testimonials.filter(
    (testimonial) =>
      testimonial.approved &&
      testimonial.courseTaken.toLowerCase().includes(courseName.toLowerCase())
  );
};

/**
 * Get testimonials by location
 */
export const getTestimonialsByLocation = (location: string): Testimonial[] => {
  return testimonials.filter(
    (testimonial) =>
      testimonial.approved &&
      testimonial.location.toLowerCase().includes(location.toLowerCase())
  );
};

/**
 * Get testimonials by rating
 */
export const getTestimonialsByRating = (minRating: number): Testimonial[] => {
  return testimonials.filter(
    (testimonial) => testimonial.approved && testimonial.rating >= minRating
  );
};
